import { createApp } from 'vue';
import GifToWebpConverter from '../Components/GifToWebpConverter.vue';

const root = document.getElementById('gif-to-webp-converter');
if (root) {
  createApp(GifToWebpConverter).mount('#gif-to-webp-converter');
}
